// extracted by mini-css-extract-plugin
export var divider = "_io-0";
export var systemMessage = "_io-1";
export var systemMessageWrapper = "_io-2";